import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { lastValueFrom, Subscription } from 'rxjs';

import _ from 'lodash';

import { ProductsService } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule, PrimeModule } from '@module';
import { InitialNameService } from '@shared';

import { DynamicDropdownComponent } from 'pn-core-code';

@Component({
  selector: 'shared-product-with-image-dropdown',
  standalone: true,
  imports: [DefaultModule, PrimeModule, DynamicDropdownComponent],
  templateUrl: './shared-product-with-image-dropdown.component.html',
  styleUrl: './shared-product-with-image-dropdown.component.scss',
  // providers: [InitialNameService]
})
export class SharedProductWithImageDropdownComponent implements OnInit, OnChanges {
  @Input() value: any;
  @Input() id: any;
  @Input() name: any;
  @Output() valueChange = new EventEmitter();
  productCategoryList: any[] = [];
  selectedList: any;
  currentLang: string;
  
  dataSub: Subscription;
  constructor(
    private productsService: ProductsService,
    private initialNameService: InitialNameService,
    private translateService: TranslateService,
  ) {
    this.translateService.onLangChange.subscribe(t => {
      this.currentLang = t.lang;
      this.getProduct();
    });
   }

  ngOnInit(): void {
    // this.selectedList = this.value;
    this.getProduct();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      console.log('value', this.value)
    }
  }
  async getProduct() {


    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }


    this.dataSub = this.productsService.productsDropdownGet$(
      1,
      9999,
      undefined,
      undefined,
      undefined,
      true,
      'lang-product-translations-name-th,asc')
      .subscribe(data => {
        console.log('productsCategories', data);

        this.productCategoryList = _.map(data, (item) => ({
          id: item.id,
          name: this.initialNameService.initName(item),
          imageUrl: item.imageUrl,
        }));

        console.log('productsCategories', data);
        // this.rows = data.products;
        // this.page.totalCount = data.pagination.allRecord;
      });
  }

  onValueChange(event: any) {
    console.log('onValueChange', event);
    this.valueChange.emit(event);
  }
}
